import React from 'react'
import { numberWithCommas } from '../../helpers/helpers'
import { FormattedData } from '../../types'
import {
    DotIcon,
    StyledVaxBar,
    StyledVaxBarIndicator,
    StyledVaxBarWrap,
    StyledVaxGrid,
    StyledVaxGridItem,
    StyledVaxTitle,
} from './JabTracker.styled'
export function WAVaccinationBar({
    data,
    type,
    isLoading,
}: {
    data: FormattedData
    type: 'large' | 'small'
    isLoading: boolean
}) {
    const firstDoseCount = data.WA.vaccine.firstDose.count
    const secondDoseCount = data.WA.vaccine.secondDose.count
    const unvaxxedCount = numberWithCommas(data.WA.vaccine.unvaxinated.count)
    const firstDoseOnlyCount = numberWithCommas(
        firstDoseCount - secondDoseCount,
    )
    const firstAndSecondDoseCount = numberWithCommas(secondDoseCount)

    const firstDosePercentage = data.WA.vaccine.firstDose.percent
    const secondDosePercentage = data.WA.vaccine.secondDose.percent
    const unvaxxedPercentage = data.WA.vaccine.unvaxinated.percent

    const firstDoseOnlyPercentage = firstDosePercentage - secondDosePercentage
    const firstAndSecondDosePercentage = secondDosePercentage
    const barTransition = {
        ease: 'easeOut',
        duration: 1,
    }
    return (
        <StyledVaxBarWrap>
            <div>
                <h3>WA Vaccinations to date</h3>
            </div>
            <div>
                <StyledVaxBar type={type}>
                    <StyledVaxBarIndicator
                        animate={{ width: `${firstDoseOnlyPercentage}%` }}
                        transition={barTransition}
                    />

                    <StyledVaxBarIndicator
                        animate={{ width: `${firstAndSecondDosePercentage}%` }}
                        transition={barTransition}
                    />

                    <StyledVaxBarIndicator
                        animate={{ width: `${unvaxxedPercentage}%` }}
                        transition={barTransition}
                    />
                </StyledVaxBar>
            </div>
            <StyledVaxGrid type={type}>
                <StyledVaxGridItem>
                    <span>{firstDoseOnlyCount}</span>
                    <br />
                    <StyledVaxTitle>
                        <DotIcon color="blue" /> 1st dose
                    </StyledVaxTitle>
                </StyledVaxGridItem>
                <StyledVaxGridItem>
                    <span>{firstAndSecondDoseCount}</span>
                    <br />
                    <StyledVaxTitle>
                        <DotIcon color="green" />
                        1st + 2nd dose
                    </StyledVaxTitle>
                </StyledVaxGridItem>
                <StyledVaxGridItem>
                    <span>{unvaxxedCount}</span>
                    <br />
                    <StyledVaxTitle>
                        <DotIcon color="red" />
                        Unvaccinated
                    </StyledVaxTitle>
                </StyledVaxGridItem>
            </StyledVaxGrid>
        </StyledVaxBarWrap>
    )
}
